module.exports = __webpack_public_path__ + "img/pay3.1636703a.png";